/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function CodeLineNumbers({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M2.908 7.1v-.755h.764V4.761l-.772.567V4.44l.778-.541h.816v2.445H5.1V7.1H2.908ZM2.981 12.6v-.677l1.074-1.07a.819.819 0 0 0 .152-.209l.001-.002a.45.45 0 0 0 .035-.32.231.231 0 0 0-.055-.1l-.001-.001c-.043-.046-.103-.074-.195-.074a.354.354 0 0 0-.098.013.245.245 0 0 0-.17.177.448.448 0 0 0-.014.116v.1H2.9v-.1c0-.209.044-.394.135-.553a.964.964 0 0 1 .39-.371c.168-.087.363-.129.58-.129.206 0 .392.039.552.12.16.078.285.193.374.342.093.15.136.327.136.526 0 .184-.043.359-.128.524a1.912 1.912 0 0 1-.39.5l-.453.44H5.1v.748H2.981ZM13 6H7V5h6v1ZM13 11H7v-1h6v1Z" /><path fill="currentColor" fillRule="evenodd" d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm2-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Z" clipRule="evenodd" /></svg>;
}
;